import { GET_ORDERS } from "./ActionTypes";

// Action After Payload Is Returned From Api
export const getOrders = payload => ({
  type: GET_ORDERS,
  payload,
});